import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
  useHandleApiError,
} from '@sttedra_ui/framework';

import GreenWayApiResponseModel from './green-way.api-response-model.js';
import GreenWayStopsApiResponseModel from './green-way-stops.api-response-model.js';

// #region Globals
const {base} = useAxios();
const CONTEXT_BASE_PATH = 'viasverdes/getviasverdes';
const DEFAULT_TIMEOUT = 5000;
const {handleApiError} = useHandleApiError();
// #endregion

// #region Public functions

async function searchGreenWay(searchParams = {}, throwError = true) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = '/' + CONTEXT_BASE_PATH;

    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;

    const data = originalData.map((u) => new GreenWayApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    if (!throwError) {
      return handleApiError(err);
    }
    throw err;
  }
}

async function searchGreenWayStops(id) {
  try {
    const url = '/' + CONTEXT_BASE_PATH + 'paradas';
    const searchModel = {
      filters: [
        {
          field: 'idVia',
          matchMode: 'Equals',
          value: String(id),
          operator: 'And',
          index: 0,
        },
      ],
    };
    const {data: response} = await base.post(url, searchModel, {
      timeout: DEFAULT_TIMEOUT,
    });

    const {data: originalData, pageSize, pageIndex, totalResults} = response;
    const data = originalData.map((u) => new GreenWayStopsApiResponseModel(u));

    return {data, pageSize, pageIndex, totalResults};
  } catch (err) {
    return handleApiError(err);
  }
}


// #endregion

// #region Private functions
// ...
// #endregion

export {
  searchGreenWay, searchGreenWayStops,
};
